import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import type { BlackoutCoverageSummary, BlackoutRowView } from '../../tabs/blackoutDates/types';
import type { WithChecklistItemMetadata } from '../../types';
import { presentRowBase } from '../rowBase';

export interface PresentedBlackout {
  coverage: BlackoutCoverageSummary;
  opportunityTravelFrom?: string;
  opportunityTravelTo?: string;
  rows: Array<WithChecklistItemMetadata<BlackoutRowView>>;
}

const EMPTY_COVERAGE: BlackoutCoverageSummary = { blackoutDays: 0, percent: 0, status: 'requires approval' };

export function presentBlackoutRows({
  coverageRow,
  dateRows,
}: {
  coverageRow?: CmChecklist.BlackoutCoverageRow;
  dateRows: Array<CmChecklist.BlackoutDateRow>;
}): PresentedBlackout {
  const rows: Array<WithChecklistItemMetadata<BlackoutRowView>> = dateRows.map((row, index) => ({
    ...presentRowBase(row),
    festiveClear: row.evidence.festive_clear,
    field: 'Blackout Dates',
    from: row.evidence.from ?? undefined,
    name:
      row.rule_id === 'blackout-source-unavailable'
        ? 'Opportunity blackout dates unavailable'
        : row.subject.name || `Blackout ${index + 1}`,
    to: row.evidence.to ?? undefined,
    withinTravelValidity: row.evidence.within_travel_validity,
  }));

  if (!coverageRow) {
    return { coverage: EMPTY_COVERAGE, rows };
  }

  const coverageBase = presentRowBase(coverageRow);

  return {
    coverage: {
      blackoutDays: coverageRow.evidence.blackout_days,
      percent: coverageRow.evidence.coverage_percent,
      status: coverageBase.status,
      travelDays: coverageRow.evidence.travel_days ?? undefined,
    },
    opportunityTravelFrom: coverageRow.evidence.travel_from ?? undefined,
    opportunityTravelTo: coverageRow.evidence.travel_to ?? undefined,
    rows: [
      ...rows,
      {
        ...coverageBase,
        festiveClear: true,
        field: 'Blackout Coverage',
        name: 'Blackout coverage rule',
        withinTravelValidity: true,
      },
    ],
  };
}
